import { COMMITMENT } from '../actions/types'

const initialState = []

const commitmentDataReducer = (state = initialState, action) => {
  switch (action.type) {
    case COMMITMENT:
      return action.payload
    default:
      return state
  }
}

export default commitmentDataReducer
